// Auto-generated locale barrel — do NOT edit by hand.
import de from './de';
import en from './en';
import es from './es';
import hu from './hu';
import it from './it';
import tr from './tr';
import cs from './cs';
import pl from './pl';
import pt from './pt';
import ro from './ro';
import sk from './sk';
import sr from './sr';
import fr from './fr';
import nl from './nl';
import sv from './sv';
import bg from './bg';
import el from './el';
import sl from './sl';
import sq from './sq';
import mk from './mk';
import uk from './uk';
import ru from './ru';
import mt from './mt';
import lb from './lb';
import ar from './ar';
import zh from './zh';
import ja from './ja';
import ko from './ko';
import hi from './hi';

export const translations = {
  de,
  en,
  es,
  hu,
  it,
  tr,
  cs,
  pl,
  pt,
  ro,
  sk,
  sr,
  fr,
  nl,
  sv,
  bg,
  el,
  sl,
  sq,
  mk,
  uk,
  ru,
  mt,
  lb,
  ar,
  zh,
  ja,
  ko,
  hi,
};

export default translations;
